import { CanMarshal } from "src/app/shared-module/models/canMarshal.model";

export class AuthToken extends CanMarshal<AuthToken> {
	public provider: "kappas" | "auth0"
	public token: string
	public createdAt: Date
	public lastLoginAt: any
}